import { useDispatch } from 'react-redux';

import { ValidatedTextInput } from '@opendoor/bricks-next';

import { trackAnswerChange } from 'src/components/fields/trackAnswerChange';
import { EmailQuestion } from 'src/lib/flow/FlowQuestion';
import { changeAnswers } from 'src/store/sellerInput';

type EmailInputProps = {
  question: EmailQuestion;
  value?: string;
};

const EmailInput: React.FC<EmailInputProps> = ({ question, value }) => {
  const dispatch = useDispatch();
  const { key, placeholder, label, helperText, optional } = question;
  return (
    <ValidatedTextInput
      title={label || ''}
      id={key}
      name={key}
      format="emailAddress"
      placeholder={placeholder}
      required={!optional}
      prefilledValue={value ?? ''}
      onChangeText={(text: string) => {
        const answer = text ?? null;
        dispatch(changeAnswers([{ key, answer }]));
      }}
      onBlur={() => trackAnswerChange(key, value ?? undefined)}
      customErrorMessages={{
        invalidEmail: `Hm, looks like that isn't a valid email.`,
      }}
      size="large"
      supportText={helperText}
      analyticsName="reception-fe-question-email"
    />
  );
};

export default EmailInput;
